var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer_badge_left",style:({ opacity: _vm.saleEndDate(_vm.product) ? 1 : 0 })},[_c('span',[_vm._v("On Sale Thru "+_vm._s(_vm.saleEndDate(_vm.product)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }